import { INSIGHT_CATEGORY_META } from '../../telas/insights/tela10-adapter';

import type { InsightCategory } from '../../types';
import type React from 'react';

// Convertido de badges-3.jsx:124-138 (window.X → import; map → INSIGHT_CATEGORY_META compartilhado).
export function InsightCategoryBadge({
  category,
}: {
  category: InsightCategory;
}): React.JSX.Element | null {
  const m = INSIGHT_CATEGORY_META[category];
  if (m === undefined) return null;
  return (
    <span className={`insight-cat insight-cat--${m.tone}`}>
      <span aria-hidden="true">{m.icon}</span>
      {m.label}
    </span>
  );
}
